// extracted by mini-css-extract-plugin
export default {"container":"OrganizeBackup_container__LtBtO","schema":"OrganizeBackup_schema__KAsbr","text":"OrganizeBackup_text__TIzd4","textItalic":"OrganizeBackup_textItalic__cVy0R"};